import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import React, { useCallback, useRef } from 'react'
import DropdownChevron from 'LuxKit/Dropdown/DropdownChevron'
import FilterChip from 'LuxKit/Chips/FilterChip'
import CalendarRoomDropdown from './CalendarRoomDropdown'

interface Props {
  open: boolean;
}

function CalendarRoomSelect(props: Props) {
  const { open } = props
  const triggerRef = useRef<HTMLButtonElement | null>(null)

  const dispatch = useOfferPageDispatch()

  const onToggleOpen = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'room' })
  }, [dispatch])

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeSubFilter })
  }, [dispatch])

  return (
    <>
      <FilterChip
        size="medium"
        ref={triggerRef}
        onClick={onToggleOpen}
        endIcon={<DropdownChevron open={open} />}
      >
        Filter by room
      </FilterChip>
      <CalendarRoomDropdown
        open={open}
        anchorRef={triggerRef}
        triggerRef={triggerRef}
        onClose={onClose}
      />
    </>
  )
}

export default withOfferPageState((state) => ({
  open: state.activeSubFilter === 'room',
}), CalendarRoomSelect)
